/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateBulkStorageObjectRequest } from '../../models/update-bulk-storage-object-request';

export interface UpdateBulkStorageObject$Params {
  assetId: string;
      body: UpdateBulkStorageObjectRequest
}

export function updateBulkStorageObject(http: HttpClient, rootUrl: string, params: UpdateBulkStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateBulkStorageObject.PATH, 'put');
  if (params) {
    rb.path('assetId', params.assetId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateBulkStorageObject.PATH = '/v0/storageObjects/bulk/{assetId}';
